var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBullseye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 183,
    viewBox: "0 0 175 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_7572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5 79.4145L0 166.914H87.5H175L87.5 79.4145Z",
    fill: "#FFD31F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4999 140.767C121.384 140.767 148.852 113.298 148.852 79.4145C148.852 45.5304 121.384 18.062 87.4999 18.062C53.6159 18.062 26.1475 45.5304 26.1475 79.4145C26.1475 113.298 53.6159 140.767 87.4999 140.767Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5004 124.222C112.247 124.222 132.308 104.161 132.308 79.4145C132.308 54.6677 112.247 34.6065 87.5004 34.6065C62.7536 34.6065 42.6924 54.6677 42.6924 79.4145C42.6924 104.161 62.7536 124.222 87.5004 124.222Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5 108.449C103.535 108.449 116.534 95.4496 116.534 79.4145C116.534 63.3793 103.535 50.3802 87.5 50.3802C71.4649 50.3802 58.4658 63.3793 58.4658 79.4145C58.4658 95.4496 71.4649 108.449 87.5 108.449Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4998 94.3313C95.7382 94.3313 102.417 87.6528 102.417 79.4145C102.417 71.1761 95.7382 64.4976 87.4998 64.4976C79.2615 64.4976 72.583 71.1761 72.583 79.4145C72.583 87.6528 79.2615 94.3313 87.4998 94.3313Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.881 122.801C119.779 133.902 104.441 140.772 87.4996 140.772C70.5577 140.772 55.2196 133.907 44.1182 122.801L87.4996 79.4194L130.881 122.801Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.881 122.801C119.779 133.902 104.441 140.772 87.4996 140.772C70.5577 140.772 55.2196 133.907 44.1182 122.801L87.4996 79.4194L130.881 122.801Z",
    fill: "#091F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.181 111.096C111.067 119.21 99.8747 124.222 87.4999 124.222C75.125 124.222 63.9326 119.21 55.8184 111.096L87.4999 79.4145L119.181 111.096Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.027 99.9466C102.77 105.203 95.5176 108.453 87.4991 108.453C79.4806 108.453 72.2232 105.203 66.9717 99.9466L87.4991 79.4192L108.027 99.9466Z",
    fill: "#091F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0454 89.9606C95.3502 92.6606 91.6162 94.3313 87.4993 94.3313C83.3823 94.3313 79.6531 92.6606 76.9531 89.9606L87.4993 79.4145L98.0454 89.9606Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.576 8.85477L89.7764 73.6547L93.4491 77.3274L158.249 12.5275L154.576 8.85477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4216 77.356L89.7499 73.6794L87.6914 79.4145L93.4216 77.356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.639 11.3121L146.397 20.7093L153.041 14.0647L149.288 4.66272L142.639 11.3121Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.052 17.8993L139.81 27.2965L146.454 20.6471L142.701 11.2499L136.052 17.8993Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.794 24.4673L146.396 20.7093L153.041 14.0647L162.438 17.8179L155.794 24.4673Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.207 31.0544L139.81 27.2965L146.454 20.6471L155.856 24.405L149.207 31.0544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 166.914H0V182.411H175V166.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6914 12.1499V0",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0329 21.0684L47.958 10.5461",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3406 45.617L18.8184 39.5421",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2358 79.2278H8.08594",
    stroke: "black",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_7572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 182.411,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBullseye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Bullseye.9181f78906a79ba0b498a167910ba286.svg";